import React from "react";
import { useSearchParams } from "react-router-dom";
import { PageShell } from "../components/PageShell";

export default function BevestigdPage({ kind = "baseline" }) {
  const [params] = useSearchParams();
  const week = params.get("week");
  const al = params.get("al") === "1";
  const title = kind === "followup" ? `Follow-up week ${week} ingediend` : "Vragenlijst ingediend";

  return (
    <PageShell title={title}>
      <div data-testid="bevestigd-page" className="rounded-lg border border-green-300 bg-green-50 p-6">
        <h1 className="text-2xl font-semibold text-green-900">Bedankt voor uw deelname!</h1>
        {al ? (
          <p className="mt-3 text-sm text-green-900">
            U heeft deze vragenlijst eerder al ingevuld. Uw antwoorden zijn dus al bekend bij ons. Bedankt!
          </p>
        ) : (
          <>
            <p className="mt-3 text-sm text-green-900">
              Wij gaan met uw werkgever de planning afstemmen — u ontvangt bericht via e-mail wanneer
              de volgende stap (aanmeting of follow-up) gepland staat.
            </p>
            {kind === "baseline" && (
              <p className="mt-2 text-sm text-green-900">
                U mag deze pagina sluiten. Bij vragen kunt u contact opnemen via{" "}
                <a className="underline" href="mailto:info@fulkraworks.nl">info@fulkraworks.nl</a>.
              </p>
            )}
            {kind === "followup" && week === "4" && (
              <p className="mt-2 text-sm text-green-900">
                Over ongeveer 8 weken ontvangt u nog een vragenlijst over de inloopperiode. Daarna is uw deelname compleet.
              </p>
            )}
            {kind === "followup" && week === "12" && (
              <p className="mt-2 text-sm text-green-900">
                Dit was uw laatste vragenlijst. Uw deelname is hierbij afgerond — heel hartelijk bedankt.
              </p>
            )}
          </>
        )}
      </div>
    </PageShell>
  );
}
